import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import SiteLayout from "./components/layout/SiteLayout.jsx";
import { loadPageStyle } from "./components/layout/pageStyles.js";

// A route resolves only once both its code and its stylesheet have loaded,
// so it never paints unstyled and then shifts.
const page = (load, style) => lazy(() => Promise.all([load(), loadPageStyle(style)]).then(([module]) => module));

const About = page(() => import("./pages/About.jsx"), "about.css");
const Contact = page(() => import("./pages/Contact.jsx"), "contact.css");
const Home = page(() => import("./pages/Home.jsx"), "index.css");
const Projects = page(() => import("./pages/Projects.jsx"), "project.css");
const Services = page(() => import("./pages/Services.jsx"), "service.css");

export default function App() {
  return (
    <Suspense fallback={<div className="route-loader" role="status">Loading FinFlux…</div>}>
      <Routes>
        <Route element={<SiteLayout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="services" element={<Services />} />
          <Route path="projects" element={<Projects />} />
          <Route path="contact" element={<Contact />} />
          <Route path="index.html" element={<Navigate to="/" replace />} />
          <Route path="about.html" element={<Navigate to="/about" replace />} />
          <Route path="service.html" element={<Navigate to="/services" replace />} />
          <Route path="project.html" element={<Navigate to="/projects" replace />} />
          <Route path="contact.html" element={<Navigate to="/contact" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
